module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Regular Italic TH.66307ec5.woff";